import { Owner } from "../../owners/shared/owner.model";
import { Respondent } from "../../respondents/shared/respondent.model";

export class AuthKey {
  public authMessage: string;
  public id: number;
  public key: string;
  public notes: string;
  public owner: Owner;
  public ownerID: number;
  public respondent: Respondent;
  public respondentID: number;
}
